module.exports = __webpack_public_path__ + "img/Lemon_and_Mint_ViewportSolid.31b54b0b.png";